import Path from "@core/FileProvider/Path/Path";
import type { WorkspaceConfig } from "@ext/workspace/WorkspaceConfig";
import { isManagedStorageSource } from "./isManagedStorageSource";
import { isShortEditorPath, shortenEditorPath } from "./shortEditorPath";

/**
 * The pathname a catalog of the managed storage (GES) goes by: the host is dropped. Only a catalog named after its
 * repository reads back from the short form: a catalog in a commit (`repo:commit-…`) keeps the host.
 */
export const toManagedStoragePathname = (
	config: Partial<WorkspaceConfig> | null | undefined,
	sourceName: string,
	pathname: string,
): string => {
	if (!config || !isManagedStorageSource(config, sourceName)) return pathname;
	const shortPath = shortenEditorPath(new Path(pathname));
	return isShortEditorPath(shortPath.value.split("/")) ? shortPath.value : pathname;
};
